export default __webpack_public_path__ + "static/media/filtersDash.318c220d.svg";